const map = {
	"./BankTransfer.png": 82680,
	"./Clover.png": 11768,
	"./Easypay.png": 17607,
	"./GoCardless.png": 54904,
	"./InStore.png": 87055,
	"./PayPal.png": 74114,
	"./PonchoPay.png": 13338,
	"./Saferpay.png": 35044,
	"./Stripe.png": 47484,
	"./Voucher.png": 67813,
	"./ePay.png": 37618,
	"./takepayments.png": 23859
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31095;